import { Button, Flex, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface ImpersonationModalActionsProps {
  onResetImpersonation: () => void;
  onApply: () => void;
  applyLabel?: string;
  applyDisabled?: boolean;
  summary?: ReactNode;
}

export function ImpersonationModalActions({
  onResetImpersonation,
  onApply,
  applyLabel = 'Apply',
  applyDisabled = false,
  summary,
}: ImpersonationModalActionsProps) {
  return (
    <Flex
      justify="space-between"
      align="center"
      gap={4}
      flexWrap={{ base: 'wrap', md: 'nowrap' }}
    >
      <Button
        variant="outline"
        colorScheme="red"
        onClick={onResetImpersonation}
        data-testid="reset-impersonation-settings-button"
      >
        Reset Impersonation
      </Button>
      {summary && (
        <Text
          fontSize="xs"
          color="gray.600"
          flex="1"
          textAlign={{ base: 'left', md: 'right' }}
          mr={{ md: 2 }}
          noOfLines={2}
          data-testid="impersonation-apply-summary"
        >
          {summary}
        </Text>
      )}
      <Button
        colorScheme="blue"
        onClick={onApply}
        isDisabled={applyDisabled}
        data-testid="apply-custom-overrides-button"
      >
        {applyLabel}
      </Button>
    </Flex>
  );
}
